module.exports = __webpack_public_path__ + "img/lr-cb66-010.799a9c00.gif";